import React from 'react';
import { ArrowRight } from 'lucide-react';

export default function StartTodayButton({ className = "", variant = "default", type = "primary" }) {
  // Primary = burnt orange for critical CTAs, Secondary = yellow for non-critical
  const typeClasses = {
    primary: "bg-[#BB3E00] hover:bg-[#8B2E00] text-white focus-visible:ring-[#BB3E00]",
    secondary: "bg-[#FFD965] hover:bg-[#E5B84A] text-[#000000] focus-visible:ring-[#FFD965]"
  };
  
  const baseClasses = "inline-flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2";
  
  const variantClasses = {
    default: "text-base",
    large: "text-lg px-8 py-4",
    small: "text-sm px-4 py-2"
  };

  return (
    <a
      href="https://app.motifunbound.com"
      target="_blank"
      rel="noopener noreferrer"
      className={`${baseClasses} ${typeClasses[type]} ${variantClasses[variant]} ${className}`}
    >
      Start Today
      <ArrowRight size={18} />
    </a>
  );
}
